import { render } from "./SurfaceScene.vue?vue&type=template&id=113cac22&scoped=true"
import script from "./SurfaceScene.vue?vue&type=script&lang=js"
export * from "./SurfaceScene.vue?vue&type=script&lang=js"

import "./SurfaceScene.vue?vue&type=style&index=0&id=113cac22&scoped=true&lang=css"

import exportComponent from "C:\\sw\\ar-unity-renderer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113cac22"]])

export default __exports__